import { ActionType } from 'typesafe-actions';
import { put, takeEvery } from 'redux-saga/effects';

import { downloadExtendedReport } from 'APIPackage/MainModule/services/reportsApi';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';
import { addNoticeImportNotification } from 'CorePackage/NotificationModule/common/addNoticeImportNotification';
// import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
// import { IKnoOrganizationDictionary } from 'APIPackage/DictionariesModule/interfaces/IKnoOrganizationDictionary';

import { reportsDownloadExtendedReport } from '../actions/reportsActions';
import { ReportsActionsEnum } from '../enums/ReportsActionsEnum';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';

export function* watchReportsSaga() {
  yield takeEvery(ReportsActionsEnum.REPORTS_DOWNLOAD_EXTENDED_REPORT, reportsDownloadExtendedReportSaga);
}

function* reportsDownloadExtendedReportSaga(action: ActionType<typeof reportsDownloadExtendedReport>) {
  function* funcTry() {
    const {
      activeItem,
      values,
      correctiveOption: {
        hasFederalLawName,
        hasMonth,
        hasOrganizations,
        hasSpecialOrganizationsIncluded,
        hasProsecutors,
        hasYear,
        hasPlanNumber,
        hasPeriod,
      },
    } = action.payload;

    const getKnoId = () => {
      if (!hasOrganizations) return undefined;

      return values?.control?.id ?? undefined;
    };

    const exportData: IExport =
      activeItem?.type &&
      (yield downloadExtendedReport({
        type: activeItem.type,
        format: values?.type?.value || undefined,
        year: hasYear ? Number(values?.year?.id) || undefined : undefined,
        month: hasMonth ? Number(values?.month?.id) || undefined : undefined,
        knoId: getKnoId(),
        // knoErvkId:
        //   hasOrganizations && values.control?.value
        //     ? (values.control as IDictionarySelectOption<IKnoOrganizationDictionary>).value.dictVersionId
        //     : undefined,
        prosecutorOrgId: hasProsecutors ? values?.prosecutor?.id ?? undefined : undefined,
        isChildKnoIncluded: hasOrganizations ? values?.controlCheckbox : undefined,
        isSpecialAndMilitaryProsecutorOrgIncluded:
          hasOrganizations && hasSpecialOrganizationsIncluded ? values.specialControlCheckbox : undefined,
        isChildProsecutorOrgIncluded: hasProsecutors ? values?.prosecutorCheckbox : undefined,
        startDate:
          hasPeriod && values.startDate
            ? formatDate({
                date: values.startDate,
                dateFormat: SYSTEM_DATE_FORMAT_FNS,
                parseFormat: DATE_FORMAT_LONG_FNS,
              })
            : undefined,
        endDate:
          hasPeriod && values.endDate
            ? formatDate({
                date: values.endDate,
                dateFormat: SYSTEM_DATE_FORMAT_FNS,
                parseFormat: DATE_FORMAT_LONG_FNS,
              })
            : undefined,
        planId: hasPlanNumber ? values?.number ?? undefined : undefined,
        federalLawName: hasFederalLawName ? values.federalLawName?.label || undefined : undefined,
        service: activeItem.service,
      }));

    if (exportData && exportData.id) {
      yield put(addNoticeImportNotification(exportData.id));
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}
